ko.components.register('project-backlinks-chart', {
	viewModel: function(params) {
		var self = this;

		self.name = ko.observable(params.name || 'backlinks');
		self.project = ko.observable(params.project || '');
		self.params = ko.observable(params.params || {});

		self.navigation = ko.observableArray(params.navigation || []);
		self.selected = ko.observable(params.selected || '');

		self.data = ko.observableArray(params.data || []);
		self.options = ko.observable(params.options || {});

		self.noDataMessage = ko.observable(params.noDataMessage || 'No data to display');

		self.loading = ko.observable(false);
		self.hasData = ko.observable(true);

		self.getData = ko.computed(function(){
			return self.data()
				.filter(function(i){ return !i.hidden(); })
				.map(function(i){ return i.data(); });
		});

		self.isSelected = function(item) {
			if(self.selected() && item) {
				return self.selected() === item.action;
			}
			return false;
		};

		self.selectChart = function(item) {
			self.selected(item.action);
			self.loadData(item.action);
		};

		self.getItemAttrs = function(item) {
			var attrs = {};
			if(item) {
				if(!item.hidden())
					attrs.checked = 'checked';
			}
			return attrs;
		};

		self.toggleVisibility = function(item) {
			if(item.hidden()) {
				item.hidden(false);
			} else {
				item.hidden(true);
			}
		};

		self.loadData = function(action) {
			if(self.loading())
				return;
			self.loading(true);
			App.ajaxRequest(self.name() + '/' + action, self.params()).done(function(r) {
				if(r && r.ok) {
					if(r.data && r.data.data) {
						self.hasData(true);
						self.data(r.data.data.map(function(item){ return new AhrefsData(item); }));
						self.options(r.data.options || {
							grid: {
								hoverable: true,
								clickable: true
							},
							series: {
								lines: { show: true },
							},
							legend: {
								show: true,
								container: $('.backlinks-chart-legend:first')
							},
							xaxis: {
								show: true,
								mode: "time",
								timeBase: "milliseconds",
								minTickSize: [1, "day"],
								timeformat: "%Y-%m-%d"
							}
						});
					} else {
						self.hasData(false);
					}
				}
			}).always(function() {
				self.loading(false);
			});
		};

		self.loadNavigation = function() {
			self.selected('');
			self.navigation.removeAll();

			App.ajaxRequest(self.name() + '/list', self.params()).done(function(r) {
				if(r && r.ok) {
					if(r.items) {
						self.navigation(r.items);
						var item = r.items.shift();
						if(item) self.selectChart(item);
					}
				}
			});
		};

		self.loadNavigation();

		$(".backlinks-chart-view").unbind("plothover").bind("plothover", function (event, pos, item) {
			if (!pos.x || !pos.y) {
				return;
			}
			var $tooltip = $(event.target).parent().find(".backlinks-chart-tooltip");
			if(item) {
				var x = new Date(item.datapoint[0]),
					y = item.datapoint[1];
				$tooltip.html(
					'<span class="backlinks-chart-tooltip-label" style="color:' + item.series.color + '">' + item.series.label + '</span> ' +
					'<span class="backlinks-chart-tooltip-date">' + x.toDateString() + '</span> ' +
					'<span class="backlinks-chart-tooltip-value">' + ('' + y).trimRight('.0') + '</span>'
				).show();
			} else {
				$tooltip.hide();
			}
		});
	},
	template: "<div class=\"row\">\n\t<div class=\"col-md-9 col-lg-10\" style=\"min-height:600px\">\n\t\t<span class=\"spinner spinner-border text-success\" data-bind=\"visible: loading()\" style=\"position:absolute;z-index:1;\"></span>\n\t\t<div class=\"backlinks-chart-view\" data-bind=\"visible: hasData(), flot: {'data': getData(), 'options': options() }\"></div>\n\t\t<div class=\"row\" data-bind=\"visible: hasData()\">\n\t\t\t<div class=\"col\"><div class=\"backlinks-chart-legend\"></div></div>\n\t\t\t<div class=\"col\">\n\t\t\t\t<div class=\"backlinks-chart-tooltip\">\n\t\t\t\t\t<span class=\"backlinks-chart-tooltip-label\"></span>\n\t\t\t\t\t<span class=\"backlinks-chart-tooltip-value\"></span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"alert alert-warning\" data-bind=\"text: noDataMessage(), visible: !hasData()\">\n\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-3 col-lg-2 border-gray border-left\">\n\t\t<ul class=\"list-group list-group-flush backlinks-chart-navigation\" data-bind=\"foreach: navigation()\">\n\t\t<li class=\"list-group-item list-group-item-action cursor-pointer\" data-bind=\"text: label, click: $component.selectChart, css: {'active': $component.isSelected($data)}\"></li>\n\t\t</ul>\n\n\t\t<br />\n\t\t<br />\n\n\t\t<ul class=\"list-group list-group-flush backlinks-chart-navigation\" data-bind=\"foreach: data()\">\n\t\t<li class=\"list-group-item list-group-item-action cursor-pointer\" data-bind=\"css: {'active': !hidden()}, click: $component.toggleVisibility\">\n\t\t\t<span class=\"ic ic-chart\" data-bind=\"visible: !hidden()\"></span>\n\t\t\t<span class=\"ic ic-remove\" data-bind=\"visible: hidden()\"></span>\n\t\t\t<span data-bind=\"text: label()\"></span>\n\t\t</li>\n\t\t</ul>\n\t</a>\n\t</div>\n</div>"
});